import { styled, Typography } from '@mui/material';

export const ImageStyled = styled('img')({
  width: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
});

export const TitleStyled = styled(Typography)({
  wordWrap: 'break-word',
}) as typeof Typography;

export const MessageContentStyled = styled(Typography)({
  wordWrap: 'break-word',
}) as typeof Typography;
